/**
 * Default messages for FormBuilder translation keys
 * These provide fallback text when Redux messages are unavailable
 */
const DEFAULT_FORM_MESSAGES: Record<string, string> = {
  // Application Name fields
  'AOB.common_config.securitysystems.systemname.title': 'Application Name',
  'AOB.common_config.securitysystems.systemname.description':
    'Enter the name of your application',
  'AOB.common_config.securitysystems.systemname.toggle': 'Application Toggle',

  // Description fields
  'AOB.common_config.endpoints.description.title': 'Description',
  'AOB.common_config.endpoints.description.description':
    'Enter a description for this endpoint',

  // Owner/User fields
  'AOB.common_config.endpoints.ownerkey.title': 'Owner',
  'AOB.common_config.endpoints.ownerkey.description':
    'Select the owner for this endpoint',

  // Connection fields
  'Target URL': 'Target URL',
  'Enter Target URL': 'Enter the target URL for connection',
  Username: 'Username',
  'Enter Target Username': 'Enter the username for connection',
  Password: 'Password',
  'Enter Target Password': 'Enter the password for connection',

  // Generic fallbacks
  'Default Labels': 'Field Label',
  'Default Label Description': 'Field Description',
  'Default Placeholder': 'Enter value',
};

export default DEFAULT_FORM_MESSAGES;
